const SUPPORT_DATA = {
    supportTiles: {
        supportTileList: [{
            image: "https://cdn2.unrealengine.com/fortnite-support-1120x640-250760681.jpg",
            logo: "FN",
            title: "Fortnite",
            url: "https://www.epicgames.com/help/c75/c95"
        }, {
            image: "https://cdn2.unrealengine.com/rl-support-1120x630-250760422.jpg",
            logo: "RL",
            title: "Rocket League",
            url: "https://www.epicgames.com/help/c-Rocket_Racing"
        }]
    },
    title: "epic.common.support_site.title"
};

export default SUPPORT_DATA;
